'use client';

import { useState, useEffect } from 'react';
import { isExtensionConnected } from '@/lib/extension-bridge';

export function useExtension() {
  const [connected, setConnected] = useState<boolean | null>(null);

  useEffect(() => {
    isExtensionConnected().then(setConnected);
    // Re-check every 30s
    const interval = setInterval(() => {
      isExtensionConnected().then(setConnected);
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  return { connected, checking: connected === null };
}
